/* eslint-disable no-use-before-define */

import PeliasResult from './result';

const PeliasRequest = function (options) {
  const autoCompleteEndpoint = 'v1/autocomplete';
  const reverseEndpoint = 'v1/reverse';
  options = options || {};
  const baseUrl = options.baseUrl || 'https://api.geocode.earth/';
  const limit = options.limit;
  const layers = options.locationType || 'coarse';
  const typeConversion = {
    address: 'address,locality',
    city: 'locality,borough',
    state: 'region,locality,borough',
    country: 'country',
  };

  this.autoComplete = function (term, callback) {
    const params = {
      text: term,
    };
    call(autoCompleteEndpoint, params, callback);
  };

  this.reverseGeocode = function (lat, lng, callback) {
    const params = {
      'point.lat': lat,
      'point.lon': lng,
    };
    call(reverseEndpoint, params, callback);
  };

  function resultsFrom(data) {
    const seen = {};
    return $.map(data.features, function (datum) {
      const result = new PeliasResult(datum);
      const key = result.displayName;
      if (seen[key]) return null;
      seen[key] = true;
      return result;
    });
  }

  function call(endpoint, params, callback) {
    $.ajax({
      url: url(endpoint, requestParams(params)),
      success: function (data) {
        callback(resultsFrom(data));
      },
      error: function () {
        callback([]);
      },
    });
  }

  function url(endpoint, params) {
    return baseUrl + endpoint + '?' + params;
  }

  function requestParams(params) {
    const instanceParams = {
      api_key: window.LocationControl.Providers.Pelias.apiKey,
      layers: typeConversion[layers] || 'coarse',
      size: limit,
    };
    params = $.extend({}, instanceParams, params);

    return $.param(params);
  }
};

export default PeliasRequest;
